<template>
  <div>
    <v-text-field
      v-model="cmpValue"
      :label="label"
      :placeholder="placeholder"
      persistent-placeholder
      persistent-hint
      :disabled="disabled"
      :required="isRequired"
      :type="type"
      class="text-caption"
      dense
      outlined
      dark
      validate-on-blur
      @blur="$emit('blur')"
      @click="$emit('click', $event)"
      @click:append="$emit('click:append', $event)"
      @click:prepend="$emit('click:prepend', $event)"
      @click:prepend-inner="$emit('click:prepend-inner', $event)"
      @focus="$emit('focus')"
      @keydown="$emit('keydown')"
      @mousedown="$emit('mousedown')"
      @mouseup="$emit('mouseup')"
      @change="$emit('change', $event, value)"
      v-bind="$attrs"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  model: { prop: 'value', event: 'input' },
  props: {
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    value: {
      type: [String],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'datetime-local',
    },
  },
  methods: {
    formatToDate(value) {
      // 2020.10.31 08:00:00 para 2020-10-30T08:00:00
      if (!value) return value

      let ne = value
        ? value
            .replace(/\./g, '-')
            .substring(0, 19)
            .replace(' ', 'T')
        : undefined

      return ne
    },
  },
  computed: {
    cmpValue: {
      get: function() {
        return this.formatToDate(this.value)
      },
      set: function(v) {
        this.$emit('input', v)
      },
    },
  },
}
</script>

<style lang="scss" scoped></style>
